export default "__VITE_ASSET__B$e3q2ru__"